module.exports = __webpack_public_path__ + "static/media/restful_api.88f7355f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/restful_api.jpg
// module id = 156
// module chunks = 0